module.exports = __webpack_public_path__ + "img/profitAnalysisRight@1x.243bcb04.png";